module.exports = ".selected {\r\n    background-color:lightgreen;\r\n}\r\n"